import React, {useState, useEffect} from "react";
import {Card, CardBody, Button} from "reactstrap";
import {useTranslation} from "react-i18next";
import {useHistory, useParams, Link, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";

import SearchBar from "../../components/others/SearchBar";
import TableFirst from "../../components/tables/TableFirst";
import Layout from "../../layout/layout";
import Breadcrumb from "../../components/common/Breadcrumb";
import DeleteModal from "../../components/modals/DeleteModal";
import DriverRuleModal from "../../components/modals/DriverRuleModal";

import { ReactComponent as CircleIcon } from '../../assets/icons/circleloaderfive.svg'

import {deleteRule, getAvailableRules, getRuleList} from "../../redux/actions/ruleActions";
import capitalizeFirstLetter from "../../helpers/capitalizeHelper";

const RulesList = () => {

    const {t} = useTranslation();
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    const available = useSelector((el) => el.systemData.availableList)
    const ruleData = useSelector((el)=> el.ruleData)
    const rules = useSelector((el)=> el.ruleData.availableRules)

    const [deleteId, setDeleteId] = useState(null)
    const [addModalShow, setAddModalShow] = useState(false)
    const [ruleSearch, setRuleSearch] = useState()

    useEffect(() => {
        if(!available.some((el) => el._id === params.systemId)){
            history.push(`/systems`)
        } else {
            dispatch(getRuleList(params.systemId,1, null));
            dispatch(getAvailableRules());
        }
    }, [location.pathname])

    const getDataList=(page)=>{
        dispatch(getRuleList(params.systemId, page, ruleSearch ? ruleSearch : null))
    }

    const onDeleteRule=()=>{
        let id = deleteId;
        setDeleteId(null)
        dispatch(deleteRule(id, params.systemId))
    }

    const onRuleSearch=()=>{
        dispatch(getRuleList(params.systemId,1, ruleSearch))
    }

    const tableColumns = [
        {
            key: "details",
            text: "",
            dataField: "name",
            headerStyle: {backgroundColor: "white"},
            formatter: (rowContent, row) => {
                return (
                    <div className="d-flex">
                        <div className="me-3 d-flex align-items-center">
                            <div className='pe-4'>
                                <CircleIcon/>
                            </div>
                        </div>
                        <div className="row-details">
                            <div className='text-new-dark fw-bold font-size-13'>{row.name}</div>

                            <div className='fw-light text-semi-dark font-size-12'>{row?.rule?.name}</div>
                            <div className='fw-light text-semi-dark font-size-12'>{t("main.lastUpdate")}: {moment(row.updatedAt).format('YY/MM/DD H:m')}</div>
                        </div>
                    </div>
                );
            },
        },
        {
            key: "status",
            text: "",
            dataField: "status",
            headerStyle: {backgroundColor: "white"},
            style: {paddingRight: '200px'},
            formatter: (rowContent, row) => {
                return (
                    <div className="d-flex justify-content-center">
                        <div className='text-semi-dark'>{t("main.status")}:</div>
                        <div className='fw-bold ps-1'>{row.status? capitalizeFirstLetter(row.status?.state) : 'None'}</div>
                    </div>
                );
            },
        },
        {
            key: "edit-delete-save",
            text: "",
            dataField: "",
            style: {textAlign: "right"},
            headerStyle: {backgroundColor: "white", boxShadow: "0"},
            formatter: (rowContent, row) => {
                return (
                    <div className="text">
                        <Link to={`/system/${params.systemId}/rule/view/${row._id}`}><Button color="primary">{t("main.view")}</Button></Link>
                        <Link to={`/system/${params.systemId}/rule/edit/${row._id}`}><Button color="warning" className="ms-2">{t("main.edit")}</Button></Link>
                        <Button onClick={() => setDeleteId(row._id)} color="danger" className="ms-2">{t("main.delete")}</Button>
                    </div>
                );
            },
        },
    ];

    return (
        <Layout>
            <div>
                <Breadcrumb
                    title={t('rules.title')}
                    systemData={{id: params.systemId, name: available.find((el) => el._id === params.systemId)?.name}}
                    breadcrumbItems={[
                        {path: `system/${params.systemId}/dashboard`, name: t(available.find((el) => el._id === params.systemId)?.name)},
                        {path: `system/${params.systemId}/rules`, name: t('rules.breadcrumb1')}
                    ]}
                />
                <Card>
                    <CardBody>
                        <div>
                            <div className='font-size-15 fw-medium'>{t("rules.pageTopic")}</div>
                            <div className='text-semi-dark mt-2 mb-4'>{t("rules.pageSubTopic")}</div>
                        </div>
                        <div>
                            <SearchBar
                                name="rule-configuration"
                                btnName={t("rules.add")}
                                link={`system/${params.systemId}/rule`}
                                searchValue={ruleSearch}
                                setSearchValue={setRuleSearch}
                                isAddModal={true}
                                setModal={setAddModalShow}
                                onSearch={onRuleSearch}
                            />
                        </div>
                        <TableFirst
                            dataList={ruleData.ruleList}
                            columns={tableColumns}
                            total={ruleData.totalSize}
                            getDataList={getDataList}
                            containerClass={'header-less-table-container drivers-table-container'}
                        />
                    </CardBody>
                </Card>
            </div>

            <DriverRuleModal
                isDriver={false}
                options={rules}
                modalShow={addModalShow}
                setModalShow={setAddModalShow}
            />

            <DeleteModal
                onDelete={onDeleteRule}
                modalShow={!!deleteId}
                setModalShow={setDeleteId}
            />

        </Layout>
    );
}

export default RulesList;
